import { cn } from "@/lib/utils";
import Image from "next/image";

interface FeatureCardProps {
  children?: React.ReactNode;
  className?: string;
  blob?: boolean;
  blobPosition?: string;
  extraOverlay?: string;
  botttomGrid?: boolean;
  pillMode?: "red" | "blue";
  overlayPosition?: string;
  divider?: boolean;
}

export function Card({
  children,
  className,
  blob,
  blobPosition = "-top-8 right-0",
  extraOverlay = "/assets/cards-images/spreadsheetGrid.svg",
  botttomGrid = false,
  pillMode = "blue",
  overlayPosition,
  divider = true,
}: FeatureCardProps) {
  const styles = {
    blue: {
      gradient:
        "bg-[radial-gradient(ellipse_at_center,rgba(31,117,254,0.8)_0%,_transparent_80%)]",
      divider: "bg-radial-blue",
    },
    red: {
      gradient:
        "bg-[radial-gradient(ellipse_at_center,rgba(200,0,0,0.6)_0%,_transparent_80%)]",
      divider: "bg-radial-red",
    },
  };

  const current = styles[pillMode];

  return (
    <div className="relative w-full">
      <div
        className={cn(
          "relative rounded-2xl z-[2] bg-background border-2 border-primaryborder overflow-hidden p-6 shadow-lg",
          className
        )}
      >
        {children}
        {blob && (
          <div
            className={cn(
              "absolute bg-white w-32 h-32 blur-3xl opacity-25 z-[-1]",
              blobPosition
            )}
          />
        )}
        {extraOverlay && (
          <Image
            src={extraOverlay}
            width={500}
            height={500}
            alt="overlay"
            className={cn(
              "absolute top-0 right-0 h-auto w-auto pointer-events-none z-[-1]",
              overlayPosition
            )}
          />
        )}

        {/* bottom gridd  */}
        {botttomGrid && (
          <>
            <div
              className={
                "absolute top-[82%] left-[180px] -z-10 w-full h-full bg-no-repeat pointer-events-none skew-x-[45deg]"
              }
              style={{
                backgroundImage: "url(/assets/grid.svg)",
                maskImage:
                  "linear-gradient(to left, rgba(0,0,0,0.1) 20%, rgba(0,0,0,1) 50%, rgba(0,0,0,0.1) 80%)",
                WebkitMaskImage:
                  "linear-gradient(to left, rgba(0,0,0,0.1) 20%, rgba(0,0,0,1) 50%, rgba(0,0,0,0.1) 80%)",
              }}
            />

            <div
              className={cn(
                "absolute bottom-0 -z-10 w-full pointer-events-none bg-gradient-to-r from-background from-10% via-[#1F75FE] to-background to-90% h-[46px] blur-[45px]",
                { "via-[#1F75FE]": pillMode === "blue" },
                { "via-[#DD2928]": pillMode === "red" }
              )}
            />
          </>
        )}
      </div>
      {/* bottom divider */}
      {divider && (
        <div
          className={cn(
            "absolute left-0 bottom-0 z-10 h-0.5 w-full",
            current.divider
          )}
        />
      )}
    </div>
  );
}
